<template>
  <div class="flex-grow-1 padding">
    <NewImagesHandler v-if="!loadingHandler" class="mb-3"
      v-model="images"
      :productId="productId"

      @upload-files="files => $emit('upload-files', files)"
      @delete-file="id => $emit('delete-file', id)"
      @update-order="ids => $emit('update-order', ids)"
    />
    <div v-else class="images-placeholder p-2 mb-3">
      <div class="ske-img ske"></div>
      <div class="ske-img ml-3 ske"></div>
      <div class="ske-img ml-3 ske"></div>
      <div class="ske-img ml-3 ske"></div>
      <div class="ske-img ml-3 ske"></div>
    </div>

    <CardTabs
      :tabs="tabs"
      v-model="tabState"
      class="card-tabs"
    />
    <template v-if="!modalOpened && isShowing && show">
      <FormRichText v-if="tabState === 'samenvatting'" v-model="$v.description.$model"
        id="description"
        :ske="true"
        :vuelidate="$v"
        field-name="description"
      />
      <FormRichText v-else-if="tabState === 'omschrijving'" v-model="$v.short_description.$model"
        id="short_description"
        :ske="true"
        :vuelidate="$v"
        field-name="short_description"
      />
    </template>
  </div>
</template>

<script>

import setupForm from "../../../mixins/setupForm"

import CardTabs from "../../../layout/CardTabs.vue"
import FormRichText from "../../Inputs/FormRichText.vue"
import NewImagesHandler from "./SidebarFields/NewImagesHandler.vue"

import { mapState } from "vuex"

const fields = ["description", "short_description"]

export default setupForm(fields, {
  components: {
    NewImagesHandler,
    CardTabs,
    FormRichText,
  },
  props: {
    productId: String,
    initialImages: Array,
    loadingHandler: Boolean,
    isShowing: Boolean,
  },
  data() {
    return {
      show: true,
      tabState: "omschrijving",
      images: this.initialImages || [],

      tabs: [
        { name: "Omschrijving", id: "omschrijving" },
        { name: "Samenvatting", id: "samenvatting" },
      ],
    }
  },
  computed: {
    ...mapState({
      modalOpened: (state) => state.modal,
    }),
    async copyDetails() {
      await this.axios.post(
        `/products/:${sku}/copy`,
      ).then((res) => {
      })
      this.$store.dispatch('clearCacheSearch', "products")
    },
  },
  watch: {
    tabState() {
      this.show = false
      this.$nextTick(() => this.show = true)
    },
    initialImages(val) {
      this.images = val
    },
    images(val) {
      this.$emit("set-images", val)
    },
  },
})

</script>

<style scoped>

.images-placeholder {
  border: 1px solid #D1D3D4;
  height: 375px;
  flex-wrap: wrap;
}

.ske-img {
  height: 125px;
  width: 125px;
}

@media (max-width: 968px) {
  .ske-img {
    margin: 0px !important;
  }
}

</style>
